import React, { useContext } from "react";
import ViewCartLink from "./ViewCartLink";
import { EventGalleryContext } from "./index";
import ArrowDown from "./vectors/ArrowDown";

interface PrintLightboxHeaderProps {
  photo: any;
  primaryColor?: string;
}

const PrintLightboxHeader: React.FC<PrintLightboxHeaderProps> = ({
  photo,
  primaryColor = "#259fa5"
}) => {
  const context = useContext(EventGalleryContext);

  const handleSelectProducts = () => {
    // Scroll to the print products section
    const printProductsSection = document.querySelector(
      ".mobile-print-products-section"
    );
    if (printProductsSection) {
      printProductsSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  const hasCartItems = () => {
    return context.cart?.photos?.includes(photo.id) || false;
  };

  return (
    <div className="geo-print-header-mobile">
      {/* Action buttons at top */}
      <div className="geo-print-header-mobile__actions">
        <button
          onClick={handleSelectProducts}
          className="scroll-lightbox-btn"
          style={{
            color: `${primaryColor}`
          }}
        >
          Select products to add to cart <ArrowDown color={primaryColor} />
        </button>

        {hasCartItems() && context.cart && (
          <ViewCartLink
            parentName="mobile-print-lightbox"
            colorTheme={primaryColor}
            cartId={context.cart.id}
            isEmbed={context.isEmbed || false}
          />
        )}
      </div>

      {/* Explanatory text below buttons */}
      <div className="geo-print-header-mobile__text"></div>
    </div>
  );
};

export default PrintLightboxHeader;
